// AgriTwinAnalytics.jsx
// Standalone analytics component for AgriLink Digital Twin

import React from 'react';

export default function AgriLinkAgriTwinAnalytics({ commodity, category, analyticsData }) {
  const { weeklyAvgTemp, weeklyAvgHumidity, moistureAlertCount, stockAlertCount, priceTrend } = analyticsData;

  return (
    <div className="p-4 bg-gray-800 rounded-xl shadow-md max-w-md mx-auto">
      <h2 className="text-lg text-yellow-200 font-semibold mb-2">Digital Twin Analytics</h2>
      <div className="text-sm text-white mb-2">Commodity: {commodity}</div>
      <div className="text-sm text-white mb-4">Category: {category}</div>

      <div className="grid grid-cols-2 gap-2 mb-4">
        <div className="p-2 bg-gray-500 rounded">
          <div className="text-xs text-white">Weekly Avg Temp</div>
          <div className="text-lg font-semibold text-yellow-200">{weeklyAvgTemp} °C</div>
        </div>
        <div className="p-2 bg-gray-500 rounded">
          <div className="text-xs text-white">Weekly Avg Humidity</div>
          <div className="text-lg font-semibold text-yellow-200">{weeklyAvgHumidity} %</div>
        </div>
        <div className="p-2 bg-gray-500 rounded">
          <div className="text-xs text-white">Moisture Alerts</div>
          <div className="text-lg font-semibold text-yellow-200">{moistureAlertCount}</div>
        </div>
        <div className="p-2 bg-gray-500 rounded">
          <div className="text-xs text-white">Stock Alerts</div>
          <div className="text-lg font-semibold text-yellow-200">{stockAlertCount}</div>
        </div>
      </div>

      <div className="p-2 bg-gray-500 rounded">
        <div className="text-xs text-white">Price Trend (₹)</div>
        <div className="flex space-x-1 mt-1">
          {priceTrend.map((p, idx) => (
            <div key={idx} className="px-2 py-1 bg-green-400 rounded text-sm font-medium">{p}</div>
          ))}
        </div>
      </div>
    </div>
  );
}
